export async function checkNotifications() {
  return {
    status: 'unavailable',
    settings: {},
  };
}

export async function requestNotifications() {
  return {
    status: 'unavailable',
    settings: {},
  };
}
